import { h, ComponentChild } from 'preact';

import { Translate } from '@travel/translation';
import Title from '@travel/traveler-core/components/Title';
import { URL_KEYS } from '@travel/traveler-core/utils/jrdpHelper';
import { Link } from '@travel/ui';
import { cx } from '@travel/utils';

import { URLSearchQuery } from 'Common-Types';
import paths from 'constants/paths';

import styles from './itineraryLink.module.scss';

type Props = {
  title?: ComponentChild;
  query?: URLSearchQuery;
};

const ItineraryLink = (props: Props) => {
  const { title, query } = props;
  if (!query?.transactionId) return null;

  return (
    <div
      class={cx(styles.itineraryLinkContainer, !title && styles.borderTop)}
      data-testid="component-itinerary-link"
    >
      <div class={cx(styles.itineraryRedirection, !title && styles.center)}>
        {title && <Title title={title} className={styles.itineraryTitle} />}
        <Link
          label={<Translate id="Hotel_List.Back_To_Itinerary" />}
          url={`${paths.itinerary.path}?${URL_KEYS.TRANSACTION_ID}=${query.transactionId}`}
          haveUnderline
        />
      </div>
      <div class={styles.overlay} />
    </div>
  );
};

export default ItineraryLink;
